import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { AppComponent } from "app/app.component";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideHttpClient, withFetch } from "@angular/common/http";
import { appConfig } from "app/app.config.server";

if (environment.production) {
  enableProdMode();

  window.console.log = function () {};

  //   const scriptEl = window.document.createElement('script');
  //   scriptEl.text = `(function(h, o, t, j, a, r) {
  //     h.hj = h.hj || function() {
  //         (h.hj.q = h.hj.q || []).push(arguments)
  //     };
  //     h._hjSettings = {
  //         hjid: 2273645,
  //         hjsv: 6
  //     };
  //     a = o.getElementsByTagName('head')[0];
  //     r = o.createElement('script');
  //     r.async = 1;
  //     r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
  //     a.appendChild(r);
  // })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');`;
  //   window.document.body.appendChild(scriptEl);

  // window._mfq = window._mfq || [];
  // (function() {
  //   var mf = document.createElement("script");
  //   mf.type = "text/javascript"; mf.defer = true;
  //   mf.src = "//cdn.mouseflow.com/projects/db9572a1-9c59-4888-86d8-72f80d29282c.js";
  //   document.getElementsByTagName("head")[0].appendChild(mf);
  // })();

  const scriptEl = window.document.createElement("script");
  scriptEl.type = "application/ld+json";
  scriptEl.async = true;
  scriptEl.text = JSON.stringify(environment.knowledgeGraphInfo);
  window.document.body.appendChild(scriptEl);

  //   const scriptGoogleTagManager = window.document.createElement('script');
  //   scriptGoogleTagManager.type = "application/javascript";
  //   scriptGoogleTagManager.async = true;
  //   scriptGoogleTagManager.text = ` <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5TZQ87W"
  //   height="0" width="0" style="display:none;visibility:hidden"></iframe>
  // </noscript>`;
  //   window.document.body.appendChild(scriptGoogleTagManager);
} else {
  // const scriptEl = window.document.createElement('script');
  // scriptEl.type = "application/ld+json";
  // scriptEl.async = true;
  // // scriptEl.text = JSON.stringify(environment.knowledgeGraphInfo);
  // window.document.body.appendChild(scriptEl);
  // const scriptGoogleTagManager = window.document.createElement('script');
  // // scriptGoogleTagManager.setAttribute('ifrmae', "https://www.googletagmanager.com/ns.html?id=GTM-5TZQ87W")
  // //    = "application/html";
  // scriptGoogleTagManager.type = "application/html";
  // scriptGoogleTagManager.async = true;
  // scriptGoogleTagManager.text = ` <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5TZQ87W"
  //   height="0" width="0" style="display:none;visibility:hidden"></iframe>
  // </noscript>`;
  // window.document.body.appendChild(scriptGoogleTagManager);
  // const scriptEl = window.document.createElement('script');
  // scriptEl.type = "application/ld+json";
  // scriptEl.text = JSON.stringify(environment.knowledgeGraphInfo);
  // window.document.body.appendChild(scriptEl);
  // alert("Inside of else ");
  // const scriptEl = window.document.createElement('script');
  // scriptEl.text = `window._mfq = window._mfq || [];
  // (function() {
  //   var mf = document.createElement("script");
  //   mf.type = "text/javascript"; mf.defer = true;
  //   mf.src = "//cdn.mouseflow.com/projects/12c9a1b7-3bf6-41a7-89ae-6b90132d4194.js";
  //   document.getElementsByTagName("head")[0].appendChild(mf);
  // })();`;
  // window.document.body.appendChild(scriptEl);
}

document.addEventListener("DOMContentLoaded", () => {
  // platformBrowserDynamic().bootstrapModule(AppModule)
  //   .catch(err => console.error(err));
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));
});
